import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { App } from './app';
import { useLang } from './lib/i18n';
import './styles/index.css';

const qc = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 10_000,
      // A 401 is handled by the client's silent refresh; retrying a 403 or 404 just
      // makes a wrong answer arrive three times.
      retry: (count, err) => count < 2 && !(err as { status?: number })?.status,
    },
  },
});

/**
 * The one place that listens for the language.
 *
 * `key` remounts the tree on a switch, so no component below has to subscribe — and none
 * can forget to. The query cache lives outside the key and survives, so switching language
 * does not refetch the whole console.
 */
function Root() {
  const lang = useLang();
  document.documentElement.lang = lang;
  return <App key={lang} />;
}

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <QueryClientProvider client={qc}>
      <Root />
    </QueryClientProvider>
  </StrictMode>,
);
